// extracted by css-extract-rspack-plugin
export default {"container":"container-TSL1Q1","loader":"loader-OmxX7h"};